import { getSpacePost, SpacePostEmbeds } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

export const GET_SPACE_POST_QK = 'getSpacePost'

const useGetSpacePost = (
  spaceId: string,
  postId: string,
  embeds: SpacePostEmbeds[] = [],
  enabled = false,
) => {
  const { refetch, data, isLoading } = useQuery({
    queryKey: [GET_SPACE_POST_QK, spaceId, postId],
    queryFn: () => getSpacePost(spaceId, postId, embeds),
    enabled,
  })

  return {
    refetch,
    post: data,
    isLoading,
  }
}

export default useGetSpacePost
